<script lang="ts" setup>
import { ref } from 'vue'

import { AdWrapper } from '@toni/brand-ui'

withDefaults(
  defineProps<{
    slotName: string,
    float?: boolean,
    minWidth?: string,
    minHeight?: string
  }>(),
  {
    float: false,
    minWidth: undefined,
    minHeight: undefined
  }
)
const adSlotRef = ref<null | HTMLElement>(null)
</script>

<template>
  <div ref="adSlotRef">
    <AdWrapper :slot-name="slotName"
               :min-width="minWidth"
               :min-height="minHeight"
               :class="{
                 'sm:float-right sm:ml-6 lg:mr-24 lg:ml-10': float,
                 'sm:mx-auto': !float
               }">
      <slot />
    </AdWrapper>
  </div>
</template>
